<school-two-column-layout>
  <admin-left-nav></admin-left-nav>
</school-two-column-layout>